
// © Microsoft Corporation. All rights reserved.

export enum GeneralCookieCategory {
    Essential = "ES",
    Advertising = "AD",
    SocialMedia = "SM",
    ThirdPartyAnalytics = "AL"
}
